<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelTipos"
    :multiple="isMulti"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    label="nome"
    :allowEmpty="allowEmpty == true"
    :preselectFirst="true"
    :loading="isLoading"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
    class="multiselect-primary"
    inputContainerClass="d-flex"
    :hide-selected="true"
  >
    <template slot="singleLabel" slot-scope="{ option }">
      <div>
        <span v-if="option"> {{ option.numero }} - {{ option.nome }} </span>
      </div>
    </template>
    <template slot="option" slot-scope="{ option }">
      <div>
        <span v-if="option"> {{ option.numero }} - {{ option.nome }} </span>
      </div>
    </template>
    <template slot="tag" slot-scope="{ option, remove }" class="d-flex">
      <span class="multiselect__tag">
        <span v-if="option">{{ option.numero }} - {{ option.nome }}</span>
        <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="remove(option)"></i>
      </span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'isTagabble',
    'allowEmpty',
    'localidadeSelected',
    'empresas',
    'alreadyAdded',
    'filterExcluido',
    'localidadeWebSelected'
  ],

  data() {
    return {
      selected: null,
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      if (e == null) {
        this.$emit('selectChange', 'id_localidade', null);
        return;
      }
      if (this.isMulti) {
        let arr = new Array();
        e.forEach((el) => {
          arr.push(el.id);
        });
        this.$emit('selectChange', 'id_localidade', arr);
      } else {
        this.$emit('selectChange', 'id_localidade', e.id);
      }
    },
    labelTipos({ nome }) {
      return `${this.$i18n.t(nome)}`;
    },
    setValue(value) {
      if (value) {
        if (this.isMulti) {
          this.selected = [];
          value.forEach((el) => {
            this.options.find((option) => option.id === el) &&
              this.selected.push(this.options.find((option) => option.id === el));
          });
        } else {
          this.selected = this.options.find((option) => option.id === parseInt(value));
        }
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },

    setOptions() {
      let id_empresa = this.$util.getIdEmpresa();

      if (this.empresas?.length) {
        id_empresa += `,${this.empresas.map((e) => e.value).join(',')}`;
      }

      let filter = `id_empresa in (${id_empresa})  `;

      const hasLocalidadeSelected = Array.isArray(this.localidadeSelected)
        ? this.localidadeSelected.length > 0
        : !!this.localidadeSelected;
      if (hasLocalidadeSelected) {
        filter += ` and (id in (${this.localidadeSelected}) or id_site is null or id_site = ${this.localidadeWebSelected})`;
      } else {
        filter += ` and (id_site is null or id_site = ${this.localidadeWebSelected})`;
      }

      this.isLoading = true;
      this.$atenaList
        .getCommon('localidade_site', {
          columns: 'id, nome, numero',
          order: 'numero',
          filter: filter
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel), numero: '' }];
          }
          this.options = this.options.concat(res.data);

          // Filtra localidadeSelected para manter apenas IDs que existem nas opções
          if (this.filterExcluido && this.localidadeSelected) {
            const validIds = this.options.map((option) => option.id);
            const isArray = Array.isArray(this.localidadeSelected);
            const hasValidLength = isArray && this.localidadeSelected.length > 0;

            if (hasValidLength || (!isArray && this.localidadeSelected)) {
              const filteredLocalidadeSelected = isArray
                ? this.localidadeSelected.filter((id) => validIds.includes(parseInt(id)))
                : validIds.includes(parseInt(this.localidadeSelected))
                ? this.localidadeSelected
                : null;

              if (JSON.stringify(filteredLocalidadeSelected) !== JSON.stringify(this.localidadeSelected)) {
                this.$emit('selectChange', 'id_localidade', filteredLocalidadeSelected);
              }
            }
          }

          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: 'Erro',
            msgContent: `${err.code} - ${err.message}`,
            msgTranslate: false,
            type: 'error'
          });
        });
    }
  },

  watch: {
    empresas(value) {
      this.setOptions();
    },
    localidadeSelected(value) {
      this.setOptions();
    },
    nameField: function (value) {
      this.setValue(value);
    }
  },

  created() {
    if (!this.filterExcluido) {
      this.setOptions();
    }
  }
};
</script>

<style lang="scss">
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
